import { ServiceClient } from 'src/utils'
import type { AdFilter, OpcoesResponse, PainelResponse } from './ad_types'

const serviceClient = ServiceClient.singleton

export class AnaliseDesempenhoService {
    private static readonly INSTANCE = new AnaliseDesempenhoService()

    public static singleton = () => AnaliseDesempenhoService.INSTANCE

    async fetchOpcoes() {
        return serviceClient().authGet<OpcoesResponse>('/api/analise-desempenho/opcoes')
    }

    async fetchPainel(filter: AdFilter) {
        return serviceClient().authPost<PainelResponse>('/api/analise-desempenho/painel', { filter })
    }
}

export default AnaliseDesempenhoService
